var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M74.052 148.104c40.898 0 74.052-33.154 74.052-74.052S114.95 0 74.052 0 0 33.154 0 74.052s33.154 74.052 74.052 74.052z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M74.053 125.544c21.92 0 39.689-2.572 39.689-5.744 0-3.173-17.77-5.745-39.69-5.745-21.92 0-39.689 2.572-39.689 5.745 0 3.172 17.77 5.744 39.69 5.744z",
  opacity: 0.7
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M53.059 117.815H47c-1.358 0-2.402-1.044-2.402-2.402l-5.222-17.652c0-1.357 1.044-2.402 2.402-2.402l13.264 3.97c1.358 0 2.403 1.044 2.403 2.401l-2.09 13.787a2.318 2.318 0 01-2.297 2.298zM94.733 117.711h6.058c1.358 0 2.402-1.045 2.402-2.403l5.118-17.651c0-1.358-1.045-2.402-2.402-2.402l-13.265 4.073c-1.358 0-2.402 1.045-2.402 2.402l2.089 13.578c.104 1.358 1.148 2.403 2.402 2.403z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M76.872 41.57v13.682h-5.849V41.569c-24.44 1.358-37.078 18.487-36.973 38.019.104 20.262 17.964 36.66 40.107 36.66 22.142-.104 40.003-16.607 39.898-36.87-.104-19.53-12.742-36.555-37.183-37.809z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M74.084 96.3c8.653-.024 15.653-5.28 15.636-11.74-.018-6.461-7.046-11.68-15.699-11.656-8.652.023-15.652 5.28-15.635 11.74.017 6.46 7.046 11.679 15.698 11.655z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M68.001 86.377c.808-.002 1.46-1.08 1.456-2.406-.004-1.327-.661-2.4-1.469-2.398-.808.002-1.46 1.08-1.456 2.406.004 1.327.662 2.4 1.47 2.398zM81.468 83.975c0 1.357-.626 2.402-1.462 2.402-.835 0-1.462-1.045-1.462-2.402 0-1.358.627-2.403 1.462-2.403.836 0 1.462 1.045 1.462 2.403zM39.794 37.914c-.105 0-.314.104-.418.209-.104.104-7.938 12.951 1.776 25.902.104.105.208.21.313.21.104 0 .104 0 .209-.105l18.173-10.654c.21-.104.21-.313.21-.522 0-.104-6.372-13.682-20.263-15.04zM106.535 37.914c-.105-.105-.209-.209-.418-.209-13.891 1.462-20.158 15.04-20.263 15.25-.104.208 0 .417.21.521l18.277 10.55c.105 0 .105.104.209.104.105 0 .209-.105.314-.21 9.713-13.16 1.775-25.902 1.671-26.006zM90.164 32.683c.166-8.94-6.946-16.32-15.885-16.487-8.94-.166-16.32 6.946-16.487 15.885-.166 8.94 6.946 16.321 15.886 16.487 8.939.166 16.32-6.946 16.486-15.885z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M87.763 32.53c.08-7.614-6.026-13.851-13.64-13.932-7.613-.08-13.85 6.027-13.931 13.64-.08 7.614 6.026 13.85 13.64 13.931 7.613.08 13.85-6.026 13.931-13.64z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M62.668 33.11c.313-6.685 6.057-11.803 12.742-11.49 3.865.21 7.311 2.194 9.4 5.223-1.88-3.76-5.744-6.372-10.236-6.58-6.684-.314-12.429 4.804-12.742 11.489-.104 2.82.627 5.43 2.089 7.52-.94-1.88-1.358-3.97-1.253-6.163z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M74.366 24.44c.522 0 .94.418.94.94v.418c1.253.105 2.297.522 3.237 1.149.314.209.627.522.627 1.044a1.16 1.16 0 01-1.149 1.15c-.209 0-.418-.105-.626-.21a11.831 11.831 0 00-2.09-.94v3.97c3.134.835 4.492 2.088 4.492 4.282 0 2.298-1.776 3.76-4.387 4.073v1.253c0 .523-.418.94-.94.94a.936.936 0 01-.94-.94v-1.253c-1.567-.209-3.029-.731-4.282-1.671-.314-.209-.522-.522-.522-1.045a1.16 1.16 0 011.148-1.148c.21 0 .523.104.732.209a6.64 6.64 0 003.029 1.357v-4.073c-3.03-.836-4.387-1.985-4.387-4.282 0-2.194 1.775-3.76 4.386-3.97v-.417c-.208-.418.21-.836.732-.836zm-.836 7.103v-3.656c-1.358.104-1.984.836-1.984 1.776 0 .73.417 1.357 1.984 1.88zm1.567 2.82v3.76c1.358-.105 2.089-.836 2.089-1.776 0-.94-.418-1.462-2.09-1.984z"
});

var SvgPiggyBank = function SvgPiggyBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 149 149",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPiggyBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/piggy-bank.6ead81a2.svg";
export { ForwardRef as ReactComponent };